import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upgradetheme',
  templateUrl: './upgradetheme.component.html',
  styleUrls: ['./upgradetheme.component.css']
})
export class UpgradethemeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
